<template>
  <Menu.Root id="switch-newsletter">
    <Menu.Trigger>
      <button
        type="button"
        class="flex min-w-0 select-none items-center gap-1.5 rounded-md px-2 py-1 text-sm font-semibold text-gray-800 outline-2 outline-blue-500 transition hover:bg-gray-200 focus-visible:outline active:bg-gray-200 data-[state=open]:bg-gray-200 dark:text-white dark:hover:bg-card dark:data-[state=open]:bg-card"
      >
        <NewsletterIcon :newsletter="current" class="-ml-1" />

        <span class="truncate">{{ current.name }}</span>
      </button>
    </Menu.Trigger>

    <Menu.Container>
      <Menu.Filter v-if="newsletters.length > 5" v-model="searchQuery" />

      <Draggable v-model="newsletters">
        <Menu.CheckboxItem
          v-for="(item, index) in filteredNewsletters"
          :key="item.id"
          :model-value="item.id === current.id"
          :index="trimmedQuery ? undefined : index"
          :label="item.name || item.username"
          :class="{
            'opacity-50': item.status === 'dormant',
          }"
          @update:model-value="accountStore.switchNewsletter(item.id)"
        >
          <template #icon>
            <NewsletterIcon :newsletter="item" />
          </template>
        </Menu.CheckboxItem>
      </Draggable>

      <Menu.RouteItem
        label="Add Newsletter"
        :to="{ name: '/settings/danger-zone/add-newsletter' }"
      >
        <template #icon>
          <PlusIcon class="size-5 rounded-md bg-muted p-1 text-foreground" />
        </template>
      </Menu.RouteItem>
    </Menu.Container>
  </Menu.Root>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import Menu from "@/design_system/Menu";
import PlusIcon from "@/icons/heroicons/plus-micro.svg";
import Draggable from "@/lib/pragmatic-dnd/Draggable.vue";
import { useAccountStore, useNewsletter } from "@/store/stores/account";

import { useSortableNewsletters } from "./lib";
import NewsletterIcon from "./NewsletterIcon.vue";

const accountStore = useAccountStore();

const current = useNewsletter();

const newsletters = useSortableNewsletters();
const searchQuery = ref("");

const trimmedQuery = computed(() => {
  return searchQuery.value.trim().toLowerCase();
});

const filteredNewsletters = computed(() => {
  const q = trimmedQuery.value;
  if (!q) {
    return newsletters.value;
  }

  return newsletters.value.filter((newsletter) => {
    const name = (newsletter.name || newsletter.username || "").toLowerCase();
    return name.includes(q);
  });
});
</script>
